"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _postAnalytics = _interopRequireDefault(require("./postAnalytics"));

var getLocation = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var setQuery, query, setLocationLoader, config, setLocation, env, location;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setQuery = _ref.setQuery, query = _ref.query, setLocationLoader = _ref.setLocationLoader, config = _ref.config, setLocation = _ref.setLocation, env = _ref.env;
            setLocationLoader(true);
            location = window.navigator && window.navigator.geolocation;

            if (!location) {
              _context.next = 10;
              break;
            }

            if (location) {
              _context.next = 8;
              break;
            }

            console.log('Geolocation not supported.');
            _context.next = 10;
            break;

          case 8:
            _context.next = 10;
            return location.getCurrentPosition(function (pos) {
              getLocationZip({
                coords: pos.coords,
                setQuery: setQuery,
                query: query,
                setLocationLoader: setLocationLoader,
                config: config,
                setLocation: setLocation,
                env: env
              });
            }, function (error) {
              console.log('Unable to retrieve current location.', error);
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getLocation(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getLocation = getLocation;

var getLocationZip = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var coords, setQuery, query, setLocationLoader, config, setLocation, env, geocoder, latLng;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            coords = _ref3.coords, setQuery = _ref3.setQuery, query = _ref3.query, setLocationLoader = _ref3.setLocationLoader, config = _ref3.config, setLocation = _ref3.setLocation, env = _ref3.env;
            geocoder = new window.google.maps.Geocoder();
            latLng = new window.google.maps.LatLng(coords.latitude, coords.longitude);
            geocoder.geocode({
              latLng: latLng
            }, function (results, status) {
              if (status == window.google.maps.GeocoderStatus.OK) {
                results[0].address_components.map(function (comp) {
                  if (comp.types[0] === 'postal_code') {
                    (0, _postAnalytics["default"])('render-user-location', {
                      store: config.title,
                      zip: comp.long_name,
                      coords: {
                        longitude: coords.longitude,
                        latitude: coords.latitude
                      }
                    }, env);
                    if (setQuery) setQuery({
                      zip: comp.long_name,
                      term: query.term
                    });
                    setLocation(comp.long_name);
                    setLocationLoader(false);
                  }
                });
              }
            });

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getLocationZip(_x2) {
    return _ref4.apply(this, arguments);
  };
}();